import { ApiError } from '../errors/api-error.js';

export class ReportProfileService {
    constructor(api) { this.api = api; }

    async index() { return this.#call(() => this.api.getIndex()); }
    async list(params = {}) { return this.#call(() => this.api.getAll(params)); }
    async getById(id) { return this.#call(() => this.api.getById(id)); }
    async create(data) { return this.#call(() => this.api.create(data)); }
    async update(id, data) { return this.#call(() => this.api.update(id, data)); }
    async remove(id, expectedVersion) { return this.#call(() => this.api.delete(id, expectedVersion)); }
    async setDefault(id, expectedVersion) { return this.#call(() => this.api.setDefault(id, expectedVersion)); }

    async #call(operation) {
        try {
            const response = await operation();
            return {
                success: response.success ?? true,
                data: response.data ?? response,
                message: response.message,
            };
        } catch (error) {
            throw error instanceof ApiError ? error : new ApiError(error.message || 'Report profile request failed');
        }
    }
}
